import React from 'react';

import {motion} from 'framer-motion';
import {fadeIn} from '../variants';

import Img1 from "../assets/Trojans.png";
import img2 from "../assets/ArtisanScribe.png";
import img3 from "../assets/excel.png";
import Img4 from "../assets/MERN-Blog2.png";
import Img5 from "../assets/KMeans.png";

const Work = () => {
  const handleClick = () =>{
    window.location="https://asprojects.netlify.app/";
  }

  return(
  <section  className="section mb-30 lg:mt-30">
    <div id="Work" className="container mx-auto lg:mt-40">
      <div className="flex flex-col lg:flex-row gap-x-10">
        <div className="flex-1 flex flex-col gap-y-12 lg:mb-0">
          <motion.div
          variants={fadeIn('right',0.5)} whileInView={'show'} viewport={{once:false,amount:0.2}}>
            <h2 className="h2 leading-tight text-fuchsia">Projects</h2>
            <p className="max-w-sm mb-2">
            All of my learning phases were associated with completing projects, as I believe that simply studying concepts can provide knowledge, but practical experience is crucial to fully understanding a topic. Here are some significant projects that I have completed
            </p>
            <a href="https://asprojects.netlify.app/" target='_blank'>
            <button onClick={handleClick} className="btn btn-sm">View all Projects
            </button>
            </a>
            </motion.div>

            
              {/* image */}
                <motion.div 
                  variants={fadeIn('left',0.01)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
                  className="group relative overflow-hidden border-2 border-white/50 rounded-xl mb-10"> 
                  {/* overlay */}
                  <div className="group-hover:bg-black/70 absolute z-40 transition-all duration-300"></div>
                  {/* img */}
                  <img className="group-hover:scale-125 w-full h-[420px] transition-all duration-500" src={Img1} alt=""/>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50"><span className="text-gradient">React JS</span></div>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                    <span className="text-3xl text-white">Symposium Website</span>
                  </div>
                  </motion.div>
                </div>
                <motion.div 
                variants={fadeIn('left',0.5)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.2}}
                className="flex-1 flex flex-col gap-y-10">
                <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl"> 
                  {/* overlay */}
                  <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                  {/* img */}
                  <img className="group-hover:scale-125 w-full h-[320px] transition-all duration-500" src={img2} alt=""/>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50"><span className="text-gradient">ReactJS and API</span></div>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                    <span className="text-3xl text-white">ArtisanScribe</span>
                  </div>
                  </div>

                  <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl"> 
                  {/* overlay */}
                  <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                  {/* img */}
                  <img className="group-hover:scale-125 w-full h-[420px] transition-all duration-500" src={img3} alt=""/>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50"><span className="text-gradient">Excel</span></div>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                    <span className="text-3xl text-white">Dashboard</span>
                  </div>
                  </div>
                </motion.div>
              


                <motion.div 
                variants={fadeIn('left',0.5)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.2}}
                className="flex-1 flex flex-col gap-y-10">
                <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl"> 
                  {/* overlay */}
                  <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                  {/* img */}
                  <img className="group-hover:scale-125 w-full h-[320px] transition-all duration-500" src={Img4} alt=""/>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50"><span className="text-gradient">MERN Stack</span></div>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                    <span className="text-3xl text-white">AS Blogs</span>
                  </div>
                  </div>

                  <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl"> 
                  {/* overlay */}
                  <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                  {/* img */}
                  <img className="group-hover:scale-125 w-full h-[420px] transition-all duration-500" src={Img5}alt=""/>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50"><span className="text-gradient">Python</span></div>
                  <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                    <span className="text-3xl text-white">Machine Learning models</span>
                  </div>
                  </div>
                </motion.div>


        </div>
      </div>
  </section>);
};

export default Work;
